import { Component, type ErrorInfo, type ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

/**
 * Límite de error por módulo (UX-ERR-01): un throw en el render de una pantalla
 * muestra un mensaje accionable en el área de contenido en vez de dejar la app
 * en blanco. El chrome (sidebar/header) sigue en pie.
 */
export class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error('Error no controlado en el módulo', error, info.componentStack);
  }

  render(): ReactNode {
    if (this.state.hasError) {
      return (
        <div className="card" role="alert" style={{ padding: 24 }}>
          <h2 style={{ fontSize: 15, marginBottom: 4 }}>
            Ocurrió un problema al mostrar esta sección
          </h2>
          <p className="soft" style={{ fontSize: 13 }}>
            Recarga la página. Si el problema persiste, contacta a soporte.
          </p>
        </div>
      );
    }
    return this.props.children;
  }
}
